export function updateStickyStack() {
  const frames = document.querySelectorAll('.frame');
  const viewport = window.innerHeight;

  frames.forEach((frame, index) => {
    frame.style.top = '';

    const cssTop = parseFloat(getComputedStyle(frame).top) || 0;

    const height = frame.offsetHeight;

    let top = cssTop;
    const minTop = viewport - height;

    if (top > minTop) top = minTop;

    frame.style.top = `${top}px`;
    frame.style.zIndex = 2 + index;
  });
}

window.addEventListener('resize', () => {
  requestAnimationFrame(updateStickyStack);
});

document.addEventListener('DOMContentLoaded', updateStickyStack);
